export function UserMessage({ content }: { content: string }) {
  return (
    <div className="flex w-full justify-end mb-6">
      <div className="flex max-w-[85%] items-start gap-3">
        <div className="bg-gray-100 text-gray-800 px-4 py-3 rounded-2xl rounded-tr-sm text-[14px] leading-relaxed">
          {content}
        </div>
        <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center text-white text-[11px] font-medium shrink-0">
          NA
        </div>
      </div>
    </div>
  );
}
